import { render, staticRenderFns } from "./DianBiaoSheBei.vue?vue&type=template&id=2335dcfa&scoped=true&"
import script from "./DianBiaoSheBei.vue?vue&type=script&lang=js&"
export * from "./DianBiaoSheBei.vue?vue&type=script&lang=js&"
import style0 from "./DianBiaoSheBei.vue?vue&type=style&index=0&id=2335dcfa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335dcfa",
  null
  
)

export default component.exports